import { connect } from 'react-redux'
import Home from '../components/Home'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  return ({
    width,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home)


// WEBPACK FOOTER //
// ./src/Pages/Home/containers/Home.js